import type { CanonicalProcessName, DienstProcessName } from './processes.api';

/** Strict whitelist matching the BFF's `:name` route enum (AD-21/CANONICAL_PROCESSES). */
export const CANONICAL_PROCESS_NAMES: readonly CanonicalProcessName[] = [
  'physical',
  'log',
  'label',
  'dangergoods',
  'marketing',
  'measure',
  'packinfo',
  'packshot',
  'labelimage',
];

/** Lens 2 groepeert de acht diensten in een digitaal- en een fysiek-blok (mockup-conform). */
export type DienstFlow = 'digitaal' | 'fysiek';

export const DIENST_FLOW: Record<DienstProcessName, DienstFlow> = {
  log: 'digitaal',
  label: 'digitaal',
  dangergoods: 'digitaal',
  marketing: 'digitaal',
  measure: 'fysiek',
  packinfo: 'fysiek',
  packshot: 'fysiek',
  labelimage: 'fysiek',
};

/** De volgorde waarin de flow-blokken onder elkaar staan. */
export const DIENST_FLOWS: readonly DienstFlow[] = ['digitaal', 'fysiek'];

/**
 * De dienstcode zoals de bron hem kent, klein onder de naam op de kaart (mockup-conform). Een code
 * is geen vertaalbare tekst — hij staat in elke taal hetzelfde en verwijst naar de bron.
 */
export const SERVICE_CODE: Record<DienstProcessName, string> = {
  log: 'LOG',
  label: 'LABEL',
  dangergoods: 'DANGERGOODS',
  marketing: 'MARKETING',
  measure: 'MEASURE',
  packinfo: 'PACKINFO',
  packshot: 'PACKSHOT',
  labelimage: 'LABELIMAGE',
};
